import React from 'react';
import { Popover } from '@hud/web-components/Popover/Popover';
import { EntityReference } from '@hud/portal-dtos/webapp-common.dto';
import styled from 'styled-components';
import { Link } from '../Link/Link';
import { ellipsisMixin } from '@hud/web-components/theme/utils';
import { smBold } from '@hud/web-components/theme/typography';
import { themeColor } from '@hud/web-components/theme/colors';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';

export interface EntitiesPopoverProps {
  entities: EntityReference[];
  entityType: 'services' | 'functions' | 'endpoints' | 'service';
  referralBreadcrumbs?: BreadcrumbItem[] | undefined;
  filtersForLink?: string;
}

export function EntitiesPopover({
  entities,
  entityType,
  referralBreadcrumbs,
  filtersForLink,
  ...rest
}: EntitiesPopoverProps) {
  if (entities.length === 0) {
    if (entityType === 'functions') {
      return '-';
    }
    return 0;
  }
  const entityTypeForLink = entityType.endsWith('s')
    ? entityType
    : `${entityType}s`;
  if (entities.length === 1) {
    return (
      <SingleEntityLink
        key={entities[0].id}
        to={`/explore/${entityTypeForLink}/${entities[0].id}${
          filtersForLink ? `?${filtersForLink}` : ''
        }`}
        state={{ referralBreadcrumbs: referralBreadcrumbs }}
      >
        <LongContentPopover>{entities[0].name}</LongContentPopover>
      </SingleEntityLink>
    );
  }
  return (
    <Popover
      width="300px"
      body={
        <EntitiesList>
          {entities.map((entity) => (
            <Link key={entity.id} to={`/explore/${entityType}/${entity.id}`}>
              {entity.name}
            </Link>
          ))}
        </EntitiesList>
      }
      {...rest}
    >
      <Counter>{entities.length}</Counter>
    </Popover>
  );
}

export const EntitiesList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;

  & a {
    ${smBold};
    ${ellipsisMixin};
    color: ${themeColor('textPrimary')};
    text-decoration: underline;
  }
`;

const Counter = styled.span`
  text-decoration: underline;
`;

export const SingleEntityLink = styled(Link)`
  color: ${themeColor('textPrimary')};
  text-decoration: underline;
`;
